// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__jwUbC","icon":"styles_icon__QjoOd","panel":"styles_panel__W7910","close":"styles_close__Ov228","row":"styles_row__Kco8p"};